import Bugsnag from '@bugsnag/js'

export interface ReportErrorOptions {
  severity?: 'info' | 'warning' | 'error'
  context?: string
  groupingHash?: string
  metadata?: { section: string; values: Record<string, unknown> }
}

export function reportError(
  error: unknown,
  options: ReportErrorOptions = {}
): void {
  if (!Bugsnag.isStarted()) {
    return
  }

  const notifiableError =
    error instanceof Error ? error : new Error(String(error))

  Bugsnag.notify(notifiableError, (event) => {
    if (options.severity) {
      event.severity = options.severity
    }
    if (options.context) {
      event.context = options.context
    }
    if (options.groupingHash) {
      event.groupingHash = options.groupingHash
    }
    if (options.metadata) {
      event.addMetadata(options.metadata.section, options.metadata.values)
    }
  })
}

export function identifyUser(id: string | number): void {
  if (!Bugsnag.isStarted()) {
    return
  }

  Bugsnag.setUser(String(id))
}
